import AnalysisPreferences from './waterAnalysis';
import CustomerPreferences from './customer';
import Dealership from './dealership';
import events from 'lib/events';
import Header from 'components/layout/header';
import Integrations from './integrations';
import IntlWrapper from 'components/layout/intlWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import session from 'services/sessionService';
import Stores from './stores';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {userLevels} from 'helpers/constants';
import {integrationsTabEnabled} from 'features';

let render = (container, params) => {
  console.info('[UI.page.settings] rendering page');
  let def = '';

  if (session.getUser().privileges.level <= userLevels.testStation) {
    events.publish('error.user', {message: <FormattedMessage id='general.error.not.authorized' />});
  } else if (session.getUser().privileges.level >= userLevels.dealerAdmin) {
    def = 'dealer';
  } else if (session.getUser().privileges.level >= userLevels.manager) {
    def = 'store';
  }
  ReactDOM.render(<IntlWrapper><WrappedSettings subPageName={params.subPage || def}/></IntlWrapper>, container);
  events.publish('page-change', {page: 'settings'});
};

console.info('[UI.page.settings] register route');
router.rr.add([{path: 'settings', handler: routeUtils.requireAuth(render)}]);
router.rr.add([{path: 'settings/:subPage', handler: routeUtils.requireAuth(render)}]);

// Page object
class Settings extends React.Component {
  static displayName = 'Settings';

  static propTypes = {
    intl: intlShape.isRequired,
    subPageName: PropTypes.string,
  };

  render() {
    let {formatMessage} = this.props.intl;

    let subPages = {
      dealer: {
        className: 'dealer-info',
        name: formatMessage({id: 'general.dealer'}),
        element: <Dealership/>,
        permissionLevel: userLevels.manager,
      },
      store: {
        className: 'stores',
        name: formatMessage({id: 'general.store'}),
        element: <Stores/>,
        permissionLevel: userLevels.manager,
      },
      customer: {
        className: 'customer-preferences',
        name: formatMessage({id: 'general.customer'}),
        element: <CustomerPreferences/>,
        permissionLevel: userLevels.manager,
      },
      'water-analysis': {
        className: 'analysis-preferences',
        name: formatMessage({id: 'general.water.analysis'}),
        element: <AnalysisPreferences/>,
        permissionLevel: userLevels.manager,
      },
      integrations: {
        className: 'integrations',
        name: formatMessage({id: 'general.integrations'}),
        element: <Integrations/>,
        permissionLevel: userLevels.dealerAdmin,
      },
    };

    let subPagesTabs = Object.keys(subPages)
      .filter(sp => subPages[sp].permissionLevel <= session.getUser().privileges.level)
      .map(sp => <a key={sp}
                    className={this.props.subPageName === sp ? subPages[sp].className + ' active' : subPages[sp].className}
                    href={'#settings/' + sp}>{subPages[sp].name}
      </a>);

    if (!integrationsTabEnabled) {
      subPagesTabs.pop();
    }

    let subPage = '';

    if (subPages[this.props.subPageName].permissionLevel <= session.getUser().privileges.level) {
      subPage = subPages[this.props.subPageName].element;
    } else {
      location.hash = '#';
    }

    return (
      <div className='container nav-tabs'>
        <Header mainTitle={formatMessage({id: 'preferences.title'})}/>
        <nav className='navigation-tabs'>
          {subPagesTabs}
        </nav>
        {subPage}
      </div>);
  }
}

const WrappedSettings = injectIntl(Settings);

export default WrappedSettings;
